import {FC, useState} from 'react'
import {Link} from 'react-router-dom'
import {AuthModel} from '../../modules/auth/core/_models'
import {
  CredentialNoticeReason,
  dismissCredentialNotice,
  resolveCredentialNotice,
} from '../../modules/auth/core/credentialNotice'

type Props = {
  user?: AuthModel
}

// «حساب کاربری › امنیت و ورود», straight at the username and password card.
const ACCOUNT_PATH = '/profile/security#profile-credentials'

const copy: Record<CredentialNoticeReason, {title: string; text: string; action: string}> = {
  'temporary-password': {
    title: 'با رمز عبور موقت وارد شده‌اید',
    text: 'رمز موقت فقط ۴۸ ساعت کار می‌کند. همین حالا رمز عبور جدیدی برای حساب خود تعیین کنید.',
    action: 'تعیین رمز جدید',
  },
  'forgot-password': {
    title: 'با کد پیامکی وارد شده‌اید',
    text: 'اگر رمز عبورتان را فراموش کرده‌اید، همین حالا رمز عبور جدیدی تعیین کنید تا دفعه‌ی بعد با آن وارد شوید.',
    action: 'تعیین رمز جدید',
  },
}

// Asks the user to set a password of their own after a temporary-password or forgot-password SMS-code sign-in
// (a missing username or password is asked for by «تکمیل حساب کاربری» before the panel opens). Closable; it returns
// on the next sign-in.
const CredentialDashboardNotice: FC<Props> = ({user}) => {
  const [closed, setClosed] = useState<CredentialNoticeReason>()
  const reason = resolveCredentialNotice(user)

  if (!reason || reason === closed) return null

  const {title, text, action} = copy[reason]

  const close = () => {
    dismissCredentialNotice(reason)
    setClosed(reason)
  }

  return (
    <section
      className='mp-sso-notice mp-sso-notice--warning mp-credential-notice'
      aria-labelledby='mp-credential-notice-title'
    >
      <i className='las la-key' aria-hidden='true' />
      <div>
        <strong id='mp-credential-notice-title'>{title}</strong>
        <small>
          {text}
          {user?.un && (
            <>
              {' '}
              نام کاربری شما:{' '}
              <bdi dir='ltr' className='mp-credential-notice__username'>
                {user.un}
              </bdi>
            </>
          )}
        </small>
      </div>
      <Link to={ACCOUNT_PATH} className='mp-sso-notice__action'>
        {action} <i className='las la-angle-left' aria-hidden='true' />
      </Link>
      <button
        type='button'
        className='mp-credential-notice__close'
        onClick={close}
        aria-label='بستن این پیام'
        title='بستن'
      >
        <i className='las la-times' aria-hidden='true' />
      </button>
    </section>
  )
}

export {CredentialDashboardNotice}
